import { render, staticRenderFns } from "./Project4.vue?vue&type=template&id=3d70f20c"
import script from "./Project4.vue?vue&type=script&lang=js"
export * from "./Project4.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports